import { render, staticRenderFns } from "./BottleNav.vue?vue&type=template&id=15cefbc2&scoped=true&"
import script from "./BottleNav.vue?vue&type=script&lang=js&"
export * from "./BottleNav.vue?vue&type=script&lang=js&"
import style0 from "./BottleNav.vue?vue&type=style&index=0&id=15cefbc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cefbc2",
  null
  
)

export default component.exports